/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { GisBody, GisHeader } from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ProjectGisClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags ProjectGis
   * @summary Получение списка идентификаторов ГИС на скважине
   * @request GET:/geology/project/{projectId}/GIS/for_well/{wellId}
   * @secure
   */
  projectGisGetGisIdsForWell = (projectId: string, wellId: string, params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/geology/project/${projectId}/GIS/for_well/${wellId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectGis
   * @summary Получение заголовков всех гисов на скважине
   * @request GET:/geology/project/{projectId}/GIS/for_well/{wellId}/all-headers
   * @secure
   */
  projectGisGetAllGisHeaders = (projectId: string, wellId: string, params: RequestParams = {}) =>
    this.http.request<GisHeader[], any>({
      path: `/geology/project/${projectId}/GIS/for_well/${wellId}/all-headers`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectGis
   * @summary Получение имен методов ГИС в проекте
   * @request GET:/geology/project/{projectId}/GIS/gis-names
   * @secure
   */
  projectGisGetAllGisNames = (projectId: string, params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/geology/project/${projectId}/GIS/gis-names`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectGis
   * @summary Получение заголовка ГИС по идентификатору
   * @request GET:/geology/project/{projectId}/GIS/{gisId}
   * @secure
   */
  projectGisGetGisHeader = (projectId: string, gisId: string, params: RequestParams = {}) =>
    this.http.request<GisHeader, any>({
      path: `/geology/project/${projectId}/GIS/${gisId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectGis
   * @summary Получение тела ГИС (с результатами измерений) по идентификатору
   * @request GET:/geology/project/{projectId}/GIS/{gisId}/data
   * @secure
   */
  projectGisGetGisBody = (projectId: string, gisId: string, params: RequestParams = {}) =>
    this.http.request<GisBody, any>({
      path: `/geology/project/${projectId}/GIS/${gisId}/data`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectGis
   * @summary Добавление ГИС в проект из непроектных данных по списку идентификаторов ГИС
   * @request POST:/geology/project/{projectId}/GIS
   * @secure
   */
  projectGisAddGisToProject = (projectId: string, data: string[], params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/geology/project/${projectId}/GIS`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectGis
   * @summary Удалит ГИС из проекта, не удаляя сами ГИС из БД.
   * @request PATCH:/geology/project/{projectId}/GIS/remove
   * @secure
   */
  projectGisRemoveGisesFromProject = (
    projectId: string,
    data: string[],
    params: RequestParams = {},
  ) =>
    this.http.request<number, any>({
      path: `/geology/project/${projectId}/GIS/remove`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
}
